var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7496 45.1501C35.0873 45.1501 45.8996 34.3378 45.8996 21.0001C45.8996 7.66242 35.0873 -3.1499 21.7496 -3.1499C8.41193 -3.1499 -2.40039 7.66242 -2.40039 21.0001C-2.40039 34.3378 8.41193 45.1501 21.7496 45.1501Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59195 6.29688C0.694948 8.76499 -0.735467 11.6097 -1.56836 14.7H10.9951L2.59195 6.29688Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0672 14.7004C44.2343 11.6102 42.8038 8.76547 40.9069 6.29736L32.5039 14.7004H45.0672Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.56836 27.3008C-0.735373 30.391 0.695043 33.2357 2.59195 35.7038L10.9948 27.3008H-1.56836Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4538 1.84253C33.9857 -0.0544689 31.1411 -1.48488 28.0508 -2.31787V10.2455L36.4538 1.84253Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 40.1578C9.51499 42.0548 12.3597 43.4852 15.4499 44.3182V31.7549L7.04688 40.1578Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4498 -2.31787C12.3596 -1.48488 9.51489 -0.0544691 7.04688 1.84244L15.4498 10.2454V-2.31787Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0508 44.3182C31.141 43.4852 33.9857 42.0548 36.4538 40.1579L28.0508 31.7549V44.3182Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5039 27.3008L40.9069 35.7038C42.8038 33.2358 44.2343 30.391 45.0672 27.3008H32.5039Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6952 17.8501H24.8998H24.8997V-2.94548C23.8685 -3.07972 22.8172 -3.1499 21.7496 -3.1499C20.6818 -3.1499 19.6307 -3.07972 18.5996 -2.94548V17.8499V17.85H-2.19596C-2.3302 18.8812 -2.40039 19.9325 -2.40039 21.0001C-2.40039 22.0679 -2.3302 23.119 -2.19596 24.1501H18.5994H18.5995V44.9457C19.6307 45.0799 20.6818 45.1501 21.7496 45.1501C22.8172 45.1501 23.8685 45.08 24.8996 44.9457V24.1503V24.1502H45.6952C45.8294 23.119 45.8996 22.0679 45.8996 21.0001C45.8996 19.9325 45.8294 18.8812 45.6952 17.8501Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0488 27.3004L38.8254 38.0769C39.321 37.5815 39.7938 37.0635 40.245 36.5265L31.0187 27.3003H28.0488V27.3004Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4485 27.3003H15.4483L4.67188 38.0768C5.16733 38.5724 5.68533 39.0452 6.22229 39.4963L15.4485 30.2699V27.3003Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.45 14.7002V14.7L4.67347 3.92334C4.17783 4.41879 3.70502 4.93679 3.25391 5.47375L12.4802 14.7001H15.45V14.7002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0488 14.7001L38.8255 3.92338C38.33 3.42774 37.812 2.95493 37.2751 2.50391L28.0488 11.7302V14.7001Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.40039 21.0001C-2.40039 7.66242 8.41193 -3.1499 21.7496 -3.1499C35.0873 -3.1499 45.8996 7.66242 45.8996 21.0001C45.8996 34.3378 35.0873 45.1501 21.7496 45.1501C8.41193 45.1501 -2.40039 34.3378 -2.40039 21.0001Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.1420d33fdbcaaae776fe1c0e8ef31eee.svg";
export { ForwardRef as ReactComponent };